import styled from "styled-components";

const Skill = styled.div`
  position: relative;
  display: inline-flex;
  color: white;
  margin-left: 10px;
  padding: 4px 8px;
`;

const Background = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  clip-path: polygon(0% 50%, 5% 0%, 95% 0%, 100% 50%, 95% 100%, 5% 100%);
`;

const Level = styled.div`
  transform: translateX(-15px);
  clip-path: polygon(0% 50%, 10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%);
  background: white;
  padding: 0 10px;
  border-radius: 5px;
  color: black;

  span {
    font-weight: 600;
  }
`;

const Name = styled.div`
  transform: translateX(-10px);
`;

const SkillStyles = {
  Skill,
  Background,
  Level,
  Name,
};

export default SkillStyles;
